import Backbone from '@polleverywhere/backbone'
import env from '@polleverywhere/core/lib/env'

const SVG_MARKUP = '<svg class="component-qrcode__svg" viewBox="0 0 451 451" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><image width="100%" height="100%" xlink:href="" href="" /></svg>'

export class QRCode extends Backbone.View {
  get className () {
    return 'component-qrcode offscreen'
  }

  events () {
    return {
      click: 'remove'
    }
  }

  initialize (options = {}) {
    this.user = options.user
  }

  remove () {
    this.$el.one('transitionend', super.remove.bind(this))
    this.$el.addClass('offscreen')
  }

  render () {
    this.$el.html(SVG_MARKUP)

    const $image = this.$('image')
    const url = env
      .get('api_url')
      .segment(['pollev_qrcodes', `${this.user.get('login')}.svg`])
      .toString()

    $image.attr('href', url)
    $image.attr('xlink:href', url)

    setTimeout(() => {
      this.$el.removeClass('offscreen')
    }, 100)

    return this
  }
}
